import { Platform, StyleSheet, Text, View } from 'react-native';
import { isPilotDeployEnvironment } from '../../../shared/dev/pilotDeployEnvironment';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { typography } from '../../../shared/theme/typography';

export function PilotDeployBanner() {
  if (Platform.OS !== 'web' || !isPilotDeployEnvironment()) {
    return null;
  }

  return (
    <View style={styles.wrap} accessibilityRole="text">
      <Text style={styles.text}>
        Entorno de prueba — no es producción. Los pagos y datos son de staging.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: ticketColors.warnBg,
    borderBottomColor: ticketColors.warnBorder,
    borderBottomWidth: StyleSheet.hairlineWidth,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  text: {
    ...typography.caption,
    color: ticketColors.warn,
    textAlign: 'center',
  },
});
